<script>
import Alert from '@/components/common/Alert'

export default Alert
</script>
